import * as React from 'react';
import { useState, useEffect } from 'react';
import {
  DialogTitle,
  Divider,
  Box,
  Stack,
  Button,
  Container,
  Typography,
  TextField,
  Modal,
  Grid,
  Snackbar,
  Alert,
} from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/styles'

export default function Users(props) {
  const theme = createTheme();

  // ---------------------Modal-------------------------------
  const [openModal, setOpenModal] = useState(true);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // width: 800,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

  // SnackBar for handling success
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');

  const [result, setResult] = useState(null);
  const [formData, setFormData] = useState({
    clientName: '',
    clientAddress: '',
    city: '',
    company: '',
    contactNo: '',
    clientDesignation: '',
  });

  // Submit Data to the Database
  // Form validity status
  const [isFormValid, setFormValid] = useState(true);

  // Submit Data to the Database
  const handleSubmit = (e) => {
    e.preventDefault();

    // Check if the form is valid
    if (!e.target.checkValidity()) {
      setFormValid(false);
      return; // Don't submit if the form is invalid
    }

    setFormValid(true);
    // get token from local storage
    const storedToken = localStorage.getItem('userToken');

    // check if token then parse into json and use it
    const token = storedToken ? JSON.parse(storedToken) : null;
  
    if (token) {
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      };
      fetch('https://quotationserver.aiodock.com/addClient', {
        method: 'POST',
        body: JSON.stringify(formData),
        headers
      })
        .then((response) => response.json())
        .then((data) => {
          setResult(data);
          setFormData({
            clientName: '',
            clientAddress: '',
            city: '',
            company: '',
            contactNo: '',
            clientDesignation: '',
          });
          setPhoneNumber('');
          setOpenSnackbar(true);
        })
        .catch(() => {
          setResult({
            success: false,
            message: 'Something went wrong. Try again later',
          });
        });
    } else {
      alert('token not found to fullfill this request');
    }
  };
  useEffect(() => {
    if (openSnackbar) {
      const snackbarTimer = setTimeout(() => {
        props.onClose();
      }, 1500);

      return () => {
        clearTimeout(snackbarTimer);
      };
    }
    return undefined;
  }, [openSnackbar]);

  // Handle Data Change
  const handleChangeData = (event) => {
    const { name, value } = event.target;
    setFormData((formData) => ({
      ...formData,
      [name]: value,
    }));
  };

  // Space after 4 digits in Phone Number
  const handlePhoneNumberChange = (event) => {
    const input = event.target.value;
    const formattedInput = input.replace(/\s/g, '').replace(/(\d{4})(.*)/, '$1 $2');
    setPhoneNumber(formattedInput);
    setFormData((formData) => ({
      ...formData,
      contactNo: formattedInput,
    }));
  };

  return (
    <>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Modal open={openModal} onClose={props.onClose}>
            <Box sx={style}>
              <ThemeProvider theme={theme}>
                <DialogTitle id="customized-dialog-title" sx={{ textAlign: 'center' }}>
                  Add New Client
                </DialogTitle>
                <Divider fullWidth />
                {!isFormValid && (
                  <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                    Please fill in all required fields.
                  </Typography>
                )}
                <Box component="form" id="modal-modal-description" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                  <Grid container>
                    <Grid item={6}>
                      <TextField
                        fullWidth
                        margin="normal"
                        required
                        label="Name"
                        value={formData.clientName}
                        name="clientName"
                        onChange={handleChangeData}
                        autoFocus
                        style={{ width: '22em', paddingRight: 5 }}
                      />
                    </Grid>
                    <Grid item={6}>
                      <TextField
                        style={{ width: '16.2em' }}
                        fullWidth
                        margin="normal"
                        required
                        label="Designation"
                        value={formData.clientDesignation}
                        name="clientDesignation"
                        onChange={handleChangeData}
                        autoFocus
                      />
                    </Grid>

                    <TextField
                      margin="normal"
                      fullWidth
                      required
                      label="Address"
                      value={formData.clientAddress}
                      name="clientAddress"
                      onChange={handleChangeData}
                      autoFocus
                    />

                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      label="City"
                      value={formData.city}
                      name="city"
                      onChange={handleChangeData}
                      autoFocus
                    />
                    <TextField
                      margin="normal"
                      fullWidth
                      required
                      label="Company"
                      value={formData.company}
                      name="company"
                      onChange={handleChangeData}
                      autoFocus
                    />

                    <TextField
                      margin="normal"
                      fullWidth
                      required
                      label="Contact No #"
                      value={phoneNumber}
                      onChange={handlePhoneNumberChange}
                      name="contactNo"
                      autoFocus
                    />

                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2, width: '50%' }}>
                        Create
                      </Button>
                      <Button onClick={props.onClose} variant="outlined" sx={{ mt: 3, mb: 2, mx: 3, width: '50%' }}>
                        Cancel
                      </Button>
                    </Box>
                  </Grid>
                </Box>
              </ThemeProvider>
              <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={() => setOpenSnackbar(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              >
                <Alert variant="filled" severity="success" sx={{ width: '100%' }}>
                  Client Created Succesfully!
                </Alert>
              </Snackbar>
            </Box>
          </Modal>
        </Stack>
      </Container>
    </>
  );
}
